import React from 'react';
import { CellProps } from 'react-table';

import MTableCellExpandCheckView from './MTableCellExpandCheck.view';

import { RowData } from 'views/MTable/Table.model';

type Props<T extends RowData> = CellProps<T> & {
  disableSelection?: boolean;
  rowCheckbox?: boolean;
  className?: string;
  onToggle?: () => void;
};

const MTableCellExpandCheck = <T extends RowData>(props: React.PropsWithChildren<Props<T>>): JSX.Element => {
  return (
    <MTableCellExpandCheckView
      rowCheckbox={props.rowCheckbox}
      disableSelection={props.disableSelection}
      className={props.className}
      toggleRowsSelectedProps={props.row.getToggleRowSelectedProps()}
      onToggle={props.onToggle}
    >
      {props.children}
    </MTableCellExpandCheckView>
  );
};

MTableCellExpandCheck.displayName = 'MTableCellExpandCheck';
MTableCellExpandCheck.defaultProps = {};

export default MTableCellExpandCheck;
